var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "claims-detail"
    },
    [
      _c("div", { staticClass: "info-section" }, [
        _c("div", { staticClass: "info-row" }, [
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("状态：")]),
            _vm._v(" "),
            _c("span", { staticClass: "value status-tag" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.getStatusText(_vm.detail.status)) +
                  "\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("赔付单ID：")]),
            _vm._v(" "),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.detail.srb_id))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-row" }, [
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("商家ID：")]),
            _vm._v(" "),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.detail.merchant_id))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("赔付单生成时间：")]),
            _vm._v(" "),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.detail.created_time))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-row" }, [
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("商家名称：")]),
            _vm._v(" "),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.detail.merchant_name))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("赔付原因：")]),
            _vm._v(" "),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.detail.reason))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-row" }, [
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("赔付单完成时间：")]),
            _vm._v(" "),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.detail.complete_time))
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-section" },
        [
          _c(
            "div",
            { staticClass: "table-header" },
            [
              _c(
                "el-form",
                {
                  staticClass: "search-form",
                  attrs: { inline: true, model: _vm.searchForm }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "代采计划ID" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px", "margin-right": "10px" },
                        attrs: { placeholder: "代采计划ID", clearable: "" },
                        model: {
                          value: _vm.searchForm.planid,
                          callback: function($$v) {
                            _vm.$set(_vm.searchForm, "planid", $$v)
                          },
                          expression: "searchForm.planid"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "货号" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px", "margin-right": "10px" },
                        attrs: { placeholder: "货号", clearable: "" },
                        model: {
                          value: _vm.searchForm.goods_no,
                          callback: function($$v) {
                            _vm.$set(_vm.searchForm, "goods_no", $$v)
                          },
                          expression: "searchForm.goods_no"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "款号" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px", "margin-right": "10px" },
                        attrs: { placeholder: "款号", clearable: "" },
                        model: {
                          value: _vm.searchForm.goods_kh,
                          callback: function($$v) {
                            _vm.$set(_vm.searchForm, "goods_kh", $$v)
                          },
                          expression: "searchForm.goods_kh"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "SKU编码" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px", "margin-right": "10px" },
                        attrs: { placeholder: "SKU编码", clearable: "" },
                        model: {
                          value: _vm.searchForm.sku,
                          callback: function($$v) {
                            _vm.$set(_vm.searchForm, "sku", $$v)
                          },
                          expression: "searchForm.sku"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSearch }
                    },
                    [_vm._v("查询")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-summary" }, [
                _c("div", { staticClass: "summary-info" }, [
                  _vm._v("\n          有效商品共 "),
                  _c("span", { staticClass: "highlight" }, [
                    _vm._v(_vm._s(_vm.kh_num))
                  ]),
                  _vm._v(" 款，\n          "),
                  _c("span", { staticClass: "highlight" }, [
                    _vm._v(_vm._s(_vm.goods_num))
                  ]),
                  _vm._v(" 件， 赔付总金额\n          "),
                  _c("span", { staticClass: "highlight" }, [
                    _vm._v("¥" + _vm._s(_vm.total_price))
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "operation-buttons" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "danger",
                          size: "small",
                          disabled: !_vm.hasValidItemsToCancel
                        },
                        on: { click: _vm.handleBatchCancel }
                      },
                      [_vm._v("\n            整单作废\n          ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "demanded_datetime",
                  label: "商家履约需求开始日期",
                  width: "180"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "delivery_day_text",
                  label: "承诺货期",
                  width: "120"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "delivery_datetime",
                  label: "承诺发货日期",
                  width: "180"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "planid", label: "代采计划ID", width: "120" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "plan_create_datetime",
                  label: "代采计划生成时间",
                  width: "180"
                }
              }),
              _vm._v(" "),
              _vm.detail.reason === "货期超时"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "blp_in_datetime",
                      label: "不良品入库时间",
                      width: "180"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.detail.reason === "货期超时"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "stock_in_datetime",
                      label: "良品入库时间",
                      width: "180"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.detail.reason === "缺货断货"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "cancel_datetime",
                      label: "断货时间",
                      width: "180"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.cancel_datetime || "-"))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3560712659
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.detail.reason === "缺货断货"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "cancel_user",
                      label: "断货人",
                      width: "120"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.cancel_user || "系统"))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1527894122
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "goods_no", label: "货号", width: "120" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "goods_kh", label: "款号", width: "120" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "sku", label: "SKU编码", width: "120" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "co_val", label: "颜色", width: "100" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "si_val", label: "尺码", width: "100" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "plan_price", label: "拿货单价", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.formatAmount(scope.row.plan_price)) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "slow_compensation_rate_text",
                  label: "赔付比例",
                  width: "120"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.slow_compensation_rate_text || "-"
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "slow_compensation_price",
                  label: "赔付金额",
                  width: "120"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.formatAmount(
                                scope.row.slow_compensation_price
                              )
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  fixed: "right",
                  width: "120",
                  align: "center"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        !row.is_created
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function($event) {
                                    return _vm.handleCreate(row, false)
                                  }
                                }
                              },
                              [_vm._v("\n            作废\n          ")]
                            )
                          : _c("span", { staticClass: "created-text" }, [
                              _vm._v("\n            已作废"),
                              _c("br"),
                              _vm._v(
                                "\n            " + _vm._s(row.void_admin_name)
                              ),
                              _c("br"),
                              _vm._v(
                                "\n            " +
                                  _vm._s(row.void_datetime) +
                                  "\n          "
                              )
                            ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.cancelDialogTitle,
            visible: _vm.cancelDialogVisible,
            width: "400px"
          },
          on: {
            "update:visible": function($event) {
              _vm.cancelDialogVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "cancel-dialog-content" }, [
            _c("p", [_vm._v(_vm._s(_vm.cancelDialogMessage))]),
            _vm._v(" "),
            _c("p", { staticClass: "warning-text" }, [
              _vm._v(
                "\n        作废后不能恢复，且该商品不会被同样原因生成赔付单\n      "
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.cancelDialogVisible = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "danger" }, on: { click: _vm.confirmCancel } },
                [_vm._v("确认作废")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7850bc75", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7850bc75","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/merchantClaimsOrder/detail.vue
// module id = null
// module chunks = 